var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPetalBullet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.708,
    height: 13.87
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 32844"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 543",
    d: "M16.92 6.955a11.862 11.862 0 01.788-4.26c-2.391-.9-5.961-2.249-6.394-2.385C5.114-1.642.177 6.257.128 6.337a1.016 1.016 0 00-.129.517 1 1 0 00.124.506c.049.082 4.994 8.17 11.19 6.2.269-.085 3.934-1.464 6.379-2.386a11.857 11.857 0 01-.772-4.219z",
    fill: "#009640"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 544",
    d: "M16.92 6.954v-.036H.004a.964.964 0 00.12.441c.049.082 4.994 8.17 11.19 6.2.269-.085 3.934-1.464 6.379-2.386a11.857 11.857 0 01-.773-4.219z",
    fill: "#006b2d"
  }))));
}

export default __webpack_public_path__ + "015a5a792dc2098665be8f5d25d6f810.svg";
export { SvgPetalBullet as ReactComponent };